import classNames from 'classnames';
import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';
import { SortingUtils } from '@spotahome/ui-library';
import SoyuzAnalytics from '@spotahome/soyuz-analytics';

import './SortBy.scss';

const DEFAULT_OPTIONS = SortingUtils.getSortingOptions();

const SortBy = ({ handleSortByChange, orderBy, className = '' }) => {
  const handleChange = e => {
    SoyuzAnalytics.sendGA4Event('sort', { value: orderBy });

    handleSortByChange(e.target.value);
  };

  // if POI search bar is used on map, we sort by distance. That option is hidden by default
  const hiddenFilterSort = SortingUtils.getHiddenSortingConfig(orderBy);

  const options = [
    ...DEFAULT_OPTIONS.map(option => (
      <option value={option.value} key={option.key}>
        {trans(option.key)}
      </option>
    )),
    ...(hiddenFilterSort
      ? [
          <option value={hiddenFilterSort.value} key={hiddenFilterSort.value}>
            {trans(hiddenFilterSort.key)}
          </option>
        ]
      : [])
  ];

  return (
    <div className={classNames('sort-by', className)}>
      <select
        className="sort-by__select"
        onChange={handleChange}
        value={orderBy}
      >
        {options}
      </select>
    </div>
  );
};

SortBy.propTypes = {
  handleSortByChange: PropTypes.func.isRequired,
  orderBy: PropTypes.string.isRequired,
  className: PropTypes.string
};

export default SortBy;
